import api from '@/api';

export default {
    namespaced: true,

    state: {
        accounts: [],
    },

    actions: {

        async getQuestionTags(context, obj) {
            let url = `/admin/start_question_tags?lang=${obj.lang}`;
            const response = await api.request('get', url);
            return response.data;
        },

        async editQuestionTag(context, item) {
            let url = `/admin/start_question_tags/${item.uid}`;
            const response = await api.request('put', url, item);
            return response.data;
        },
        async createQuestionTag(context, item) {
            let url = `/admin/start_question_tags`;
            const response = await api.request('post', url, item);
            return response.data;
        },
        async deleteQuestionTag(context, item) {
            let url = `/admin/start_question_tags/${item.uid}`;
            const response = await api.request('delete', url, item);
            return response.data;
        },

        async getQuestionTemplates(context, obj) {
            let url = `/admin/start_question_templates?`;
            if (obj.lang) {
                url += `lang=${obj.lang}`
            }
            const response = await api.request('get', url);
            return response.data;
        },
        async editQuestionTemplate(context, item) {
            let url = `/admin/start_question_templates/${item.uid}`;
            const response = await api.request('put', url, item);
            return response.data;
        },
        async createQuestionTemplate(context, item) {
            let url = `/admin/start_question_templates`;
            const response = await api.request('post', url, item);
            return response.data;
        },
        async deleteQuestionTemplate(context, item) {
            let url = `/admin/start_question_templates/${item.uid}`;
            const response = await api.request('delete', url, item);
            return response.data;
        },

        async attachQuestionTemplate(context, item) {
            let url = `/admin/start_question_templates/${item.question_uid}/tags/${item.tag_uid}`;
            const response = await api.request('put', url, item);
            return response.data;
        },
        async detachQuestionTemplate(context, item) {
            let url = `/admin/start_question_templates/${item.question_uid}/tags/${item.tag_uid}`;
            const response = await api.request('delete', url, item);
            return response.data;
        },

    },
    mutations: {}
};
